var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dropdown, List, Message } from "semantic-ui-react";
import { useUserActions } from "@iscr/xAppLib/Users/AdminUsers/UserActionsContext";
import { ProviderIcon } from "@iscr/xAppLib/Users/ProviderIcons";
export function UnlinkSocialsAction(_a) {
    var { content } = _a, props = __rest(_a, ["content"]);
    const { user, can, action } = useUserActions();
    if (!can("user:unlink-socials")) {
        return null;
    }
    return (_jsx(Dropdown.Item, Object.assign({}, props, (content ? { content } : { text: "Unlink socials", icon: { name: "id card outline", color: "gray" } }), { onClick: () => __awaiter(this, void 0, void 0, function* () {
            const socials = user.auth.providerData.filter(p => p.providerId !== "password");
            const hasPassword = user.auth.providerData.some(p => p.providerId === "password");
            // Maybe we should have this a list of socials to unlink, instead of all of them? Phase 2...
            const result = yield app.confirm("Unlink social logins", _jsxs(_Fragment, { children: [_jsx("p", { children: "The user's following social accounts will be unlinked:" }), _jsx(List, { children: socials.map(p => (_jsxs(List.Item, { children: [_jsx(List.Icon, { children: _jsx(ProviderIcon, { providerId: p.providerId }) }), _jsx(List.Content, { children: p.providerId })] }, p.providerId))) }), !hasPassword && (_jsx(Message, { warning: true, children: "The user does not have a password set. They will no longer be able to log in." })), _jsx("p", { children: "Continue?" })] }));
            return result === "yes" && action({ type: "user:unlink-socials" });
        }) })));
}
